import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const initialState = {
  isLoading: false,
  confirmAction: false,
  confirmActionCard: false,
  registerSuccess: false,
  confirmPhone: null as null | string,
  backError: null as null | object | string,
  successRecallPassword: false,
  successRecoveryPassword: false,
  codes: '',
  confirmCardCode: false,
  step: 0,
  phoneForSms: '',
  cardNumber: '',
}
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIsLoading(state, { payload }: PayloadAction<boolean>) {
      state.isLoading = payload
    },
    setConfirmAction(state, { payload }: PayloadAction<boolean>) {
      state.confirmAction = payload
    },
    setConfirmActionCard(state, { payload }: PayloadAction<boolean>) {
      state.confirmActionCard = payload
    },
    setRegisterSuccess(state, { payload }: PayloadAction<boolean>) {
      state.registerSuccess = payload
    },
    setConfirmPhone(state, { payload }: PayloadAction<string>) {
      state.confirmPhone = payload
    },
    setBackError(state, { payload }: PayloadAction<object | null | string>) {
      state.backError = payload
    },
    setIsSuccessRecallPassword(state, { payload }: PayloadAction<boolean>) {
      state.successRecallPassword = payload
    },
    setIsSuccessRecoveryPassword(state, { payload }: PayloadAction<boolean>) {
      state.successRecoveryPassword = payload
    },
    setCodes(state, { payload }: PayloadAction<string>) {
      state.codes = payload
    },
    setConfirmCardCode(state, { payload }: PayloadAction<boolean>) {
      state.confirmCardCode = payload
    },
    setStep(state, { payload }: PayloadAction<number>) {
      state.step = payload
    },
    setPhoneForSms(state, { payload }: PayloadAction<any>) {
      state.phoneForSms = payload
    },
    setCardNumber(state, { payload }: PayloadAction<string>) {
      state.cardNumber = payload
    },
    logoutAC() {},
    resetAuth: () => initialState,
  },
})

export type AuthStateType = typeof initialState
export const {
  setIsLoading,
  setConfirmAction,
  setConfirmActionCard,
  setRegisterSuccess,
  setConfirmPhone,
  setBackError,
  setIsSuccessRecallPassword,
  setIsSuccessRecoveryPassword,
  setCodes,
  resetAuth,
  logoutAC,
  setConfirmCardCode,
  setStep,
  setPhoneForSms,
  setCardNumber,
} = authSlice.actions
export const authReducer = authSlice.reducer
